// extracted by mini-css-extract-plugin
export default {"label":"SwitcherInput-modules__label__R7xef","switcher":"SwitcherInput-modules__switcher__nsDqB"};